import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormControl } from "@angular/forms";
import { v4 as uuidv4 } from "uuid";

@Component({
    selector: "love-it-enum-checkbox-selector",
    templateUrl: "./enum-checkbox-selector.component.html",
    styleUrls: ["./enum-checkbox-selector.component.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: EnumCheckboxSelectorComponent,
            multi: true,
        },
    ],
    standalone: false
})
export class EnumCheckboxSelectorComponent implements OnInit, AfterViewInit, ControlValueAccessor {
  @Input() enumValues: Array<string>;

  formControls: Map<string, FormControl> = new Map<string, FormControl>();
  changeFunction: any;
  unique = uuidv4();

  constructor() {}

  ngOnInit(): void {
    for (const value of this.enumValues) {
      const fc = new FormControl(false);
      this.formControls.set(value, fc);
    }
  }

  ngAfterViewInit(): void {
    for (const value of this.enumValues) {
      this.formControls.get(value).valueChanges.subscribe(() => this.setNewValues());
    }
  }

  setNewValues() {
    const values: Array<string> = Array.from(this.formControls)
      .filter(([value, fc]) => fc.value)
      .map(([value, fc]) => value);
    this.changeFunction(values);
  }

  registerOnChange(fn: any): void {
    this.changeFunction = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(obj: Array<string>): void {
    for (const value of this.enumValues) {
      const isSet: boolean = obj?.includes(value);
      this.formControls.get(value)?.setValue(isSet);
    }
  }

  setDisabledState(isDisabled: boolean) {
    for (const fc of this.formControls.values()) {
      if (isDisabled) {
        fc.disable({ emitEvent: false });
      } else {
        fc.enable({ emitEvent: false });
      }
    }
  }
}
